import { SaasDashboardPage } from './SaasDashboardPage';
import { TenantAreaDashboardPage } from '../../tenant/dashboard/TenantAreaDashboardPage';
import { useAuthStore } from '../../../stores/authStore';

export function DashboardRouter() {
  const user = useAuthStore(state => state.user);
  return user?.isPlatformUser ? <SaasDashboardPage /> : <TenantAreaDashboardPage />;
}
